/* ============================================================================
   DY SMOOTH — GSAP + scroll suave (Lenis), cargados sin afectar la carga inicial
   - Las librerías se descargan DESPUÉS de que la página cargó y el navegador está libre.
   - Lenis solo en escritorio (mouse/trackpad). En táctil se usa el scroll nativo.
   - Solo mejora: si algo no carga, la tienda sigue igual con scroll nativo.
   - Se pausa con menús, carrito y modales abiertos (html[scroll-lock] / dialog[open]).
   - Respeta prefers-reduced-motion y el editor de temas.
   ========================================================================= */

(() => {
  'use strict';

  const script = document.currentScript;
  if (!script) return;

  const root = document.documentElement;
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const DESIGN_MODE = root.classList.contains('shopify-design-mode') || !!window.Shopify?.designMode;
  const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const USE_SMOOTH = !REDUCED && !DESIGN_MODE && FINE_POINTER;

  // Contenedores con scroll propio: la rueda del mouse se queda dentro de ellos
  const NATIVE_SCROLL = [
    '[data-lenis-prevent]',
    'dialog',
    '[role="dialog"]',
    '.menu-drawer',
    'cart-drawer',
    '.cart-drawer',
    '.drawer',
    '.predictive-search',
    '.search-modal',
    '.quick-add-modal',
    '.facets',
    'select',
    'textarea',
  ].join(',');

  const load = (src) =>
    new Promise((resolve, reject) => {
      if (!src) return reject();
      const el = document.createElement('script');
      el.src = src;
      el.async = true;
      el.onload = resolve;
      el.onerror = reject;
      document.head.appendChild(el);
    });

  const whenIdle = (fn) =>
    'requestIdleCallback' in window ? window.requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 300);

  function initLenis() {
    if (typeof window.Lenis === 'undefined') return;

    const gsap = window.gsap;
    let lenis;
    try {
      lenis = new window.Lenis({
        // Suavizado sutil: se siente premium sin "flotar" ni retrasar el scroll
        lerp: 0.14,
        wheelMultiplier: 1,
        smoothWheel: true,
        syncTouch: false,
        // Links de ancla quedan nativos para no interferir con tabs/links del tema
        anchors: false,
        allowNestedScroll: true,
        autoRaf: !gsap,
        prevent: (node) => node instanceof Element && !!node.closest(NATIVE_SCROLL),
      });
    } catch (e) {
      return;
    }

    if (gsap) {
      gsap.ticker.add((time) => lenis.raf(time * 1000));
      gsap.ticker.lagSmoothing(0);
    }

    // Pausar mientras el tema bloquea el scroll (menú móvil, carrito, modales)
    const syncLock = () => {
      const locked = root.hasAttribute('scroll-lock') || !!document.querySelector('dialog[open]');
      if (locked) lenis.stop();
      else lenis.start();
    };
    new MutationObserver(syncLock).observe(root, { attributes: true, attributeFilter: ['scroll-lock'] });
    document.addEventListener('toggle', syncLock, true);
    document.addEventListener('close', syncLock, true);
    syncLock();

    window.dyLenis = lenis;
  }

  async function boot() {
    if (!window.gsap) {
      try {
        await load(script.dataset.gsap);
      } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('dy:gsap-ready'));

    if (!USE_SMOOTH) return;
    try {
      await load(script.dataset.lenis);
      initLenis();
    } catch (e) {}
  }

  const start = () => whenIdle(boot);
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
